import useFirebase from "../Hooks/useFirebase";

export default function Page_Login({}) {
  // --------------------------------------- use context

  const [firebase_Status, firebase_SignOut, firebase_LoginUI] = useFirebase();

  return (
    <>
      <div className="FlexColumn">
        <h1>Eclipse POS</h1>
        <br />

        <br />
        <br />
        {firebase_LoginUI}
      </div>
    </>
  );
}
